import React, { useEffect } from 'react';

const Loader = () => {
    useEffect(() => {
        // Optional: Add a smooth fade-in effect when component mounts
        const timeout = setTimeout(() => {
            document.querySelector('.centered-loader-container').classList.add('fade-in');
        }, 100);

        return () => clearTimeout(timeout);
    }, []);

    return (
        <div className="centered-loader-container">
            <div className="loader-content">
                <div className="loader-logo">
                    <div className="logo-container">
                        <img
                            className="logo-main"
                            src="/assets/images/logo.png"
                            alt="Logo"
                        />
                        <div className="pulse-container">
                            <span className="pulse"></span>
                            <span className="pulse delay-1"></span>
                            <span className="pulse delay-2"></span>
                        </div>
                    </div>
                    <h2>Loading...</h2>
                </div>


                {/*<div className="skeleton-section">*/}
                {/*    <div className="skeleton-hero">*/}
                {/*        <div className="skeleton-hero-content">*/}
                {/*            <div className="skeleton-line w-50"></div>*/}
                {/*            <div className="skeleton-line w-75"></div>*/}
                {/*            <div className="skeleton-line w-25"></div>*/}
                {/*        </div>*/}
                {/*        <div className="skeleton-hero-image"></div>*/}
                {/*    </div>*/}
                {/*</div>*/}

                {/*  */}
                {/*<div className="skeleton-section">*/}
                {/*    <div className="skeleton-title"></div>*/}
                {/*    <div className="skeleton-categories">*/}
                {/*        <div className="skeleton-category">*/}
                {/*            <div className="skeleton-image"></div>*/}
                {/*            <div className="skeleton-line w-50 mx-auto mt-3"></div>*/}
                {/*        </div>*/}
                {/*        <div className="skeleton-category">*/}
                {/*            <div className="skeleton-image"></div>*/}
                {/*            <div className="skeleton-line w-50 mx-auto mt-3"></div>*/}
                {/*        </div>*/}
                {/*        <div className="skeleton-category">*/}
                {/*            <div className="skeleton-image"></div>*/}
                {/*            <div className="skeleton-line w-50 mx-auto mt-3"></div>*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</div>*/}

                {/*  */}
                {/*<div className="skeleton-section">*/}
                {/*    <div className="skeleton-title"></div>*/}
                {/*    <div className="skeleton-products">*/}
                {/*        {[1, 2, 3, 4, 5, 6].map(item => (*/}
                {/*            <div className="skeleton-product" key={item}>*/}
                {/*                <div className="skeleton-product-image"></div>*/}
                {/*                <div className="skeleton-line w-75 mt-3"></div>*/}
                {/*                <div className="skeleton-line w-50"></div>*/}
                {/*                <div className="skeleton-line w-25"></div>*/}
                {/*            </div>*/}
                {/*        ))}*/}
                {/*    </div>*/}
                {/*</div>*/}

                <style jsx>{`
                .centered-loader-container {
                    display: flex;
                    justify-content: center;
                    padding: 20px;
                    max-width: 1200px;
                    margin: 0 auto;
                    opacity: 0;
                    transition: opacity 0.8s ease-in-out;
                    overflow-x: hidden;
                    font-family: 'Roboto', sans-serif;
                }
                
                .fade-in {
                    opacity: 1;
                }
                
                .loader-content {
                    width: 100%;
                }
                
                .loader-logo {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    margin-bottom: 40px;
                    padding-top: 20px;
                }
                
                .logo-container {
                    position: relative;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 160px;
                    height: 120px;
                }
                
                .logo-main {
                    width: 160px;
                    height: 120px;
                    max-width: 100%;
                    object-fit: contain;
                    z-index: 2;
                    animation: float 3s ease-in-out infinite;
                    filter: drop-shadow(0 5px 15px rgba(0, 0, 0, 0.1));
                }
                
                @keyframes float {
                    0% {
                        transform: translateY(0);
                    }
                    50% {
                        transform: translateY(-10px);
                    }
                    100% {
                        transform: translateY(0);
                    }
                }
                
                .pulse-container {
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
                
                .loader-logo h2 {
                    color: #D4B675;
                    margin-top: 15px;
                    font-weight: 300;
                    letter-spacing: 1px;
                }
                
                .pulse {
                    position: absolute;
                    width: 140px;
                    height: 100px;
                    border-radius: 50%;
                    background-color: rgba(212, 182, 117, 0.4);
                    animation: pulse 1.8s ease-in-out infinite;
                }
                
                .delay-1 {
                    animation-delay: 0.6s;
                }
                
                .delay-2 {
                    animation-delay: 1.2s;
                }
                
                @keyframes pulse {
                    0% {
                        transform: scale(0.6);
                        opacity: 0.6;
                    }
                    50% {
                        opacity: 0.3;
                    }
                    100% {
                        transform: scale(1.2);
                        opacity: 0;
                    }
                }
                
                .skeleton-section {
                    margin-bottom: 60px;
                }
                
                .skeleton-title {
                    height: 28px;
                    width: 180px;
                    background: linear-gradient(110deg, #ececec 8%, #f5f5f5 18%, #ececec 33%);
                    border-radius: 5px;
                    background-size: 200% 100%;
                    animation: shine 1.5s infinite linear;
                    margin: 0 auto 30px auto;
                }
                
                .skeleton-hero {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 30px;
                    margin-bottom: 40px;
                }
                
                .skeleton-hero-content {
                    flex: 1;
                    min-width: 300px;
                }
                
                .skeleton-hero-image {
                    flex: 1;
                    min-width: 300px;
                    height: 300px;
                    background: linear-gradient(110deg, #ececec 8%, #f5f5f5 18%, #ececec 33%);
                    border-radius: 8px;
                    background-size: 200% 100%;
                    animation: shine 1.5s infinite linear;
                }
                
                .skeleton-line {
                    height: 20px;
                    margin-bottom: 15px;
                    background: linear-gradient(110deg, #ececec 8%, #f5f5f5 18%, #ececec 33%);
                    border-radius: 5px;
                    background-size: 200% 100%;
                    animation: shine 1.5s infinite linear;
                }
                
                .w-25 { width: 25%; }
                .w-50 { width: 50%; }
                .w-75 { width: 75%; }
                .mt-3 { margin-top: 15px; }
                .mx-auto { margin-left: auto; margin-right: auto; }
                
                .skeleton-categories {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 20px;
                    justify-content: center;
                }
                
                .skeleton-category {
                    flex: 1;
                    min-width: 250px;
                    max-width: 350px;
                    text-align: center;
                }
                
                .skeleton-image {
                    height: 200px;
                    background: linear-gradient(110deg, #ececec 8%, #f5f5f5 18%, #ececec 33%);
                    border-radius: 8px;
                    background-size: 200% 100%;
                    animation: shine 1.5s infinite linear;
                }
                
                .skeleton-products {
                    display: grid;
                    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
                    gap: 25px;
                }
                
                .skeleton-product {
                    padding: 15px;
                    border-radius: 8px;
                    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.08);
                }
                
                .skeleton-product-image {
                    height: 180px;
                    background: linear-gradient(110deg, #ececec 8%, #f5f5f5 18%, #ececec 33%);
                    border-radius: 8px;
                    background-size: 200% 100%;
                    animation: shine 1.5s infinite linear;
                }
                
                @keyframes shine {
                    to {
                        background-position-x: -200%;
                    }
                }
                
                @media (max-width: 768px) {
                    .skeleton-hero {
                        flex-direction: column;
                    }
                    
                    .skeleton-hero-image {
                        height: 200px;
                    }
                    
                    .skeleton-categories {
                        flex-direction: column;
                        align-items: center;
                    }
                    
                    .skeleton-category {
                        width: 100%;
                        max-width: 300px;
                    }
                    
                    .skeleton-products {
                        grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
                    }
                    
                    .logo-main {
                        width: 140px;
                        height: 100px;
                    }
                }
            `}</style>
            </div>
        </div>
    );
};

// To implement this in your HomePage component, replace:
// if (loading) {
//     return (<div className="loading-spinner-container">
//         <div className="loading-spinner"></div>
//         <p>Loading...</p>
//     </div>);
// }
//
// With:
// if (loading) {
//     return <Loader />;
// }

export default Loader;